"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
exports.getNodeConfig = type => {
  let nodeConfig = exports.NODE_CONFIG[type];
  if (!nodeConfig) throw new Error("Invalid node type");
  return nodeConfig;
};
exports.NODE_CONFIG = {
  [types_1.NODE_TYPES.TRIGGER]: {
    label: "Trigger",
    target: {
      script: "trigger"
    },
    description:
      "Use this to initiate a workflow based on time, events or call.",
    image: "tc-icon-trigger",
    isActive: true,
    ta: "ta_et_node_trigger"
  },
  [types_1.NODE_TYPES.RESOURCE]: {
    label: "AWS Resource",
    description: "Select AWS resources on which you want to work on.",
    image: "tc-icon-resource",
    isActive: true,
    ta: "ta_et_node_res",
    target: {
      script: "awsapi"
    }
  },
  [types_1.NODE_TYPES.FILTER]: {
    label: "Filter",
    description: "Enter parameters to filter resources in the workflow.",
    isActive: true,
    image: "tc-icon-filter",
    target: {
      script: "customFilter"
    },
    ta: "ta_et_node_filter"
  },
  [types_1.NODE_TYPES.ACTION]: {
    label: "AWS Action",
    description: "Select AWS action to be done on resources in the workflow.",
    isActive: true,
    image: "tc-icon-action",
    target: {
      script: "awsapi"
    },
    ta: "ta_et_node_action"
  },
  [types_1.NODE_TYPES.USER_APPROVAL]: {
    label: "User Approval",
    description:
      "Use this to get approval from stakeholder to continue the workflow.",
    isActive: true,
    image: "tc-icon-user-approval",
    target: {
      activity: "approval"
    },
    ta: "ta_et_node_approval"
  },
  [types_1.NODE_TYPES.NOTIFICATION]: {
    label: "Notification",
    description: "Send notification with a custom message.",
    isActive: true,
    image: "tc-icon-notification",
    target: {
      script: "notify"
    },
    ta: "ta_et_node_notify"
  },
  [types_1.NODE_TYPES.REPORT]: {
    label: "Report",
    description: "Use this node to generate advanced reports",
    isActive: true,
    image: "tc-icon-report",
    target: {
      script: "report"
    },
    ta: "ta_et_node_report"
  },
  [types_1.NODE_TYPES.MONITORING]: {
    label: "AWS Monitoring",
    description: "Fetches CloudWatch Metrics of associated resources.",
    isActive: true,
    image: "tc-icon-monitoring",
    target: {
      script: "monitoring"
    },
    ta: "ta_et_node_monitoring"
  },
  [types_1.NODE_TYPES.CUSTOM]: {
    label: "Custom",
    description: "Use this node to execute custom business logic.",
    isActive: true,
    image: "tc-icon-custom",
    target: {
      script: "customJavascript"
    },
    ta: "ta_et_node_custom"
  },
  [types_1.NODE_TYPES.DELAY]: {
    label: "Delay",
    description: "Insert a delay in execution of next step",
    isActive: true,
    image: "tc-icon-delay",
    target: {
      delay: "1"
    },
    ta: "ta_et_node_delay"
  },
  [types_1.NODE_TYPES.HTTP]: {
    label: "HTTP",
    description: "Invoke external http(s) endpoint",
    isActive: true,
    image: "fa fa-link",
    target: {
      script: "http"
    },
    ta: "ta_et_node_http"
  },
  [types_1.NODE_TYPES.JENKINS]: {
    label: "Jenkins",
    description: "trigger a jenkins job from a workflow",
    isActive: true,
    image: "fa fa-server",
    target: {
      script: "triggerJenkinsBuild"
    },
    ta: "ta_et_node_jenkins"
  },
  [types_1.NODE_TYPES.WORKFLOW]: {
    label: "Workflow Trigger",
    description: "trigger another workflow",
    isActive: true,
    image: "fa fa-code-fork",
    target: {
      script: "executeWorkflow"
    },
    ta: "ta_et_node_workflow"
  },
  [types_1.NODE_TYPES.WORKFLOW_REPORT]: {
    label: "Workflow Report",
    description: "Sends report of all active workflows",
    isActive: false,
    image: "tc-icon-report",
    target: {
      script: "workflowReport"
    },
    ta: "ta_et_node_workflow_report"
  },
  [types_1.NODE_TYPES.THROTTLING]: {
    label: "Workflow Throttling",
    description: "Allows only one execution of workflow",
    isActive: false,
    image: "tc-icon-report",
    target: {
      script: "wfThrottling"
    },
    ta: "ta_et_node_workflow_throttling"
  },
  [types_1.NODE_TYPES.ADOPTION]: {
    label: "Template Adoption",
    description: "Adopt given template ids",
    isActive: false,
    image: "tc-icon-report",
    target: {
      script: "templateAdoption"
    },
    ta: "ta_et_node_template_adoption"
  },
  [types_1.NODE_TYPES.SSH]: {
    label: "SSH",
    description: "run commands via ssh",
    isActive: true,
    image: "fa-terminal fa",
    target: {
      script: "ssh"
    },
    ta: "ta_et_node_ssh"
  },
  [types_1.NODE_TYPES.NETWORK]: {
    label: "Network Scan",
    description: "scans local network",
    isActive: true,
    image: "fa-search fa",
    target: {
      activity: "network-scan"
    },
    ta: "ta_et_node_network"
  },
  [types_1.NODE_TYPES.WOLKEN]: {
    label: "Wolken CMDB",
    description: "Interact with wolken cmdb items",
    isActive: true,
    image: "fa fa-laptop",
    target: {
      script: "wolken-cmdb"
    },
    ta: "ta_et_node_wolken_cmdb"
  },
  [types_1.NODE_TYPES.VMWARE]: {
    label: "VMware",
    description: "Interact with VMware resources",
    isActive: true,
    image: "fa fa-window-restore",
    target: {
      script: "vmware"
    },
    ta: "ta_et_node_vmware"
  },
  [types_1.NODE_TYPES.VMWARE_ACTION]: {
    label: "VMware Actions",
    description: "Interact with VMware resources",
    isActive: true,
    image: "fa fa-window-restore",
    target: {
      script: "vmware-action"
    },
    ta: "ta_et_node_vmware_action"
  },
  [types_1.NODE_TYPES.Azure_Resource]: {
    label: "Azure Resource",
    description: "Interact with Azure resources",
    isActive: true,
    image: "tc-icon-resource",
    target: {
      script: "azure-resource"
    },
    ta: "ta_et_node_azure_resource"
  },
  [types_1.NODE_TYPES.Azure_Action]: {
    label: "Azure Action",
    description: "Interact with Azure resources",
    isActive: true,
    image: "tc-icon-action",
    target: {
      script: "azure-action"
    },
    ta: "ta_et_node_azure_action"
  },
  [types_1.NODE_TYPES.Azure_Monitoring]: {
    label: "Azure Monitoring",
    description: "Fetches Azure Monitor Metrics of associated resources.",
    isActive: true,
    image: "tc-icon-monitoring",
    target: {
      script: "azure-monitoring"
    },
    ta: "ta_et_node_azure_monitoring"
  },
  [types_1.NODE_TYPES.K8_Resource]: {
    label: "Kubernetes Resource",
    description: "Interact with Kubernetes resources.",
    isActive: true,
    image: "tc-icon-resource",
    target: {
      script: "kubernetes-resource"
    },
    ta: "ta_et_node_kubernetes_resource"
  },
  [types_1.NODE_TYPES.K8_Action]: {
    label: "Kubernetes Action",
    description: "Interact with Kubernetes action.",
    isActive: true,
    image: "tc-icon-action",
    target: {
      script: "kubernetes-action"
    },
    ta: "ta_et_node_kubernetes_action"
  },
  [types_1.NODE_TYPES.Parallel]: {
    label: "Parallel Branch",
    description: "Execute multiple Branch in parallel",
    isActive: false,
    image: "tc-icon-logical",
    target: {
      script: "parallel"
    },
    ta: "ta_et_node_parallel"
  },
  [types_1.NODE_TYPES.Decision]: {
    label: "Decision",
    description: "",
    isActive: false,
    image: "tc-icon-logical",
    target: {
      script: "decision"
    },
    ta: "ta_et_node_decision"
  },
  [types_1.NODE_TYPES.TerraformCloudResource]: {
    label: "Terraform Cloud Resource",
    description: "Integrate with terraform cloud",
    isActive: true,
    image: "tc-icon-resource",
    target: {
      script: "terraformCloud"
    },
    ta: "ta_et_node_terraform_cloud"
  },
  [types_1.NODE_TYPES.TerraformCloudAction]: {
    label: "Terraform Cloud Action",
    description: "Integrate with terraform cloud",
    isActive: true,
    image: "tc-icon-action",
    target: {
      script: "terraformCloud"
    },
    ta: "ta_et_node_terraform_cloud"
  },
  [types_1.NODE_TYPES.UserDefinedNode]: {
    label: "User Defined Node",
    description: "Use a predefined custom node in workflow",
    isActive: false,
    image: "tc-icon-action",
    target: {
      script: "user-defined-node"
    },
    ta: "ta_et_node_custom_user_node"
  },
  [types_1.NODE_TYPES.DataFormatter]: {
    label: "Data formatter",
    description:
      "Node to format data based on keys selected by user and type of formatting",
    isActive: true,
    image: "tc-icon-action",
    target: {
      script: "data-formatter"
    },
    ta: "ta_et_node_data_formatter"
  },
  [types_1.NODE_TYPES.DataJoiner]: {
    label: "Data Joiner",
    description:
      "Join data for two different nodes based on conditions to return combined data",
    isActive: true,
    image: "tc-icon-logical",
    target: {
      script: "data-joiner"
    },
    ta: "ta_et_node_data_joiner"
  },
  [types_1.NODE_TYPES.GCP_Resource]: {
    label: "GCP Resource",
    description: "Perform read operation on the GCP resources",
    isActive: true,
    image: "tc-icon-resource",
    target: {
      script: "gcp-resource"
    },
    ta: "ta_et_node_gcp_resource"
  },
  [types_1.NODE_TYPES.GCP_Action]: {
    label: "GCP Action",
    description: "Perform action on GCP resources",
    isActive: true,
    image: "tc-icon-action",
    target: {
      script: "gcp-action"
    },
    ta: "ta_et_node_gcp_action"
  }
};
exports.validNodeTypes = Object.keys(exports.NODE_CONFIG).filter(x => {
  let configObj = exports.NODE_CONFIG;
  return configObj[x].isActive;
});
//# sourceMappingURL=NodesConfig.js.map
